import { render, staticRenderFns } from "./CertificationList.vue?vue&type=template&id=bb4f126c&scoped=true&"
import script from "./CertificationList.vue?vue&type=script&lang=js&"
export * from "./CertificationList.vue?vue&type=script&lang=js&"
import style0 from "./CertificationList.vue?vue&type=style&index=0&id=bb4f126c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4f126c",
  null
  
)

export default component.exports